export default __webpack_public_path__ + "1778ee140b7e2f7e3ce1dc4e2db657dc.png";